import { convertNumber } from '@/utils'
import { queryReconciliationList } from '@/api/domain/finance'
import moment from 'moment'


export default function config() {
  return {
    configData: {
      formData: {
        list: [
          {
            el: 'input',
            itemConfig: {
              label: '交易ID',
              prop: 'transactionId',
            },
            elConfig: {
              maxLength: 100,
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '付款账户',
              prop: 'transferorName',
            },
            elConfig: {
              maxLength: 100,
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '收款账户',
              prop: 'receiverName',

            },
            elConfig: {
              maxLength: 100,
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '交易类型',
              prop: 'transactionType',
            },
            elConfig: {
              options: {
                label: 'name',
                value: 'type',
                list: [],
              },
            },
          },
          {
            el: 'date-picker',
            itemConfig: {
              label: '交易时间',
              prop: 'transactionTime',
            },
            elConfig: {
              type: 'daterange',
              'range-separator': '至',
              'start-placeholder': '开始日期',
              'end-placeholder': '结束日期',
              format: 'yyyy-MM-dd',
              'value-format': 'timestamp',
              pickerOptions: {
                disabledDate: (time) => {
                  const startDate = moment().subtract(0, 'days')
                  const endDate = moment().subtract(1, 'years').subtract(2, 'days')
                  // 如果用户选择同一天，由于当天还没过完，所以在确定结束时间时会出现时间戳大于选择时间戳，导致当天无法被选中
                  // 改用日期比较方式避免以上问题
                  return moment(time).format('YYYY-MM-DD') > moment(startDate).format('YYYY-MM-DD')
                                           || moment(time).format('YYYY-MM-DD') < moment(endDate).format('YYYY-MM-DD')
                },
              },
            },
          },
        ],
        formProps: {
          model: {
            channelType: '',
          },
        },
      },
      tableData: {
        columns: [
          {
            name: 'transactionId',
            columnProps: {
              prop: 'transactionId',
              label: '交易ID',
            },
          },
          {
            name: 'transactionType',
            columnProps: {
              label: '交易类型',
              prop: 'transactionType',
            },
            getText: ({ row }) => {
              const typeObj = this.transactionTypeList?.find((item) => item.type === row.transactionType)
              return typeObj?.name
            },
          },
          {
            name: 'transferorName',
            columnProps: {
              label: '付款账户',
              prop: 'transferorName',
              width: 150,
            },
          },
          {
            name: 'receiverName',
            columnProps: {
              label: '收款账户',
              prop: 'receiverName',
              width: 150,
            },
          },
          {
            name: 'transactionAmount',
            columnProps: {
              label: '交易金额(元)',
              prop: 'transactionAmount',
              minWidth: 150,
            },
            getText: ({ row }) => convertNumber(row.transactionAmount),
          },
          {
            name: 'fee',
            columnProps: {
              label: '手续费(元)',
              prop: 'fee',
            },
            getText: ({ row }) => convertNumber(row.fee),
          },
          {
            name: 'transactionTime',
            columnProps: {
              label: '交易时间',
              prop: 'transactionTime',
              minWidth: 150,
            },
          },
          {
            name: 'thirdPartyFlowId',
            columnProps: {
              label: '银行交易流水号',
              prop: 'thirdPartyFlowId',
              width: 150,
            },
          },
          {
            name: 'operator',
            columnProps: {
              label: '交易发起人',
              prop: 'operator',
              width: 230,
            },
            render: ({ row }) => {
              // 发起人类型：0系统，1具体人员，2规则
              if (row.operatorType === 2) {
                return this.$createElement('el-link', {
                  props: {
                    underline: false,
                    type: 'primary',
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: '/finance/transferRulesConfig',
                        query: {
                          ruleId: row.operatorId,
                        },
                      })
                    },
                  },
                }, row.operator)
              }
              return row.operator
            },
          },
        ],
        apiFn: (params) => {
          const [startTime = null, endTime = null] = params.transactionTime ?? []
          delete params.transactionTime
          return queryReconciliationList({
            ...params,
            startTime,
            endTime,
          })
        },
      },
      isShowDepartment: false,
    },
  }
}
